import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../../auth/commonCSS.css";
import { useDispatch } from "react-redux";
import { loginUser } from "../../../redux/slice/authSlice/UserSlice.js";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import '../commonCSS.css'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      "Invalid email address"

    ),
  password: Yup

    .string()
    .min(8, 'Password must be 8 characters long')
    .matches(/[0-9]/, 'Password requires a number')
    .matches(/[a-z]/, 'Password requires a lowercase letter')
    .matches(/[A-Z]/, 'Password requires an uppercase letter')
    .matches(/[^\w]/, 'Password requires a symbol')

});

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      agree: false,
    },
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        const result = await dispatch(loginUser(values));

        if (loginUser.fulfilled.match(result)) {
          toast.success("Login Successful!");
          setTimeout(() => navigate("/logout"), 3000);
        } else {
          toast.error("Login failed. Please try again.");
          console.log(result.payload || "Login failed. Please try again.");
        }
      } catch (error) {
        toast.error("Login error. Please try again.");
        console.error("Login error: ", error);
      }
    },
  });

  const handleGoogleLoginSuccess = (response) => {
    try {
      const token = response.credential;
      const decoded = jwtDecode(token);
      console.log("Google User Data:", decoded);
      localStorage.setItem("userToken", token);
      localStorage.setItem("user", JSON.stringify(decoded));

      const username = decoded.name || decoded.email || "Unknown User";
      toast.success(`Hello, ${username}! You have logged in successfully.`);
      setTimeout(() => navigate("/dashboard"));
    } catch (error) {
      console.error("Error decoding Google token:", error);
      toast.error("Google login failed. Unable to process the token.");
    }
  };

  const handleGoogleLoginFailure = (error) => {
    console.error("Google login failed:", error);
    toast.error("Google login failed. Please try again.");
  };

  return (
    <>
      <section className="vh-100 login-start  bg-gradient" >
        <div className="container h-100">
          <div className="row d-flex justify-content-center align-items-center h-100 ">

            <div className="col-lg-12 col-xl-11 ">
              <div className="card text-black login-radius background-dark" >
                <div className="card-body p-md-5 ">
                  <div className="row justify-content-center ">

                    <div className="background col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1 background-dark">
                      <div className="arrow-auth">
                        <Link to="/register"> <i className="bi bi-arrow-left text-dark fs-5"></i>
                        </Link>
                  
                      </div>
                      <p className="text-center h1 fw-bold mb-5 mx-1 mx-md-4 mt-4 landing-text-white">
                        Login
                      </p>

                      <form
                        onSubmit={formik.handleSubmit}
                        className="mx-1 mx-md-4"
                      >
                        <div className="d-flex flex-row align-items-center mb-4">

                          <div className="form-outline flex-fill mb-0">
                            <div className="d-flex">
                              <i className="bi bi-envelope me-1 mt-2 landing-text-white"></i>
                              <input
                                type="email"
                                id="email"
                                name="email"
                                className={`form-control ${formik.touched.email && formik.errors.email
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                placeholder="Enter Your Email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className="text-end">
                              {formik.touched.email && formik.errors.email ? (
                                <div className="text-danger">
                                  {formik.errors.email}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-4">
                          <div className="form-outline flex-fill mb-0">
                            <div className="d-flex">
                              <i className="bi bi-lock-fill me-1 mt-2 landing-text-white"></i>
                              <input
                                type="password"
                                id="password"
                                name="password"
                                className={`form-control ${formik.touched.password &&
                                  formik.errors.password
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                placeholder="Enter Password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <div className="text-end">
                              {formik.touched.password &&
                                formik.errors.password ? (
                                <div className="text-danger">
                                  {formik.errors.password}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div className="form-check d-flex justify-content-center mb-5">
                          <input
                            className={`form-check-input me-2 ${formik.touched.agree && !formik.values.agree
                              ? "is-invalid"
                              : ""
                              }`}
                            type="checkbox"
                            id="agree"
                            name="agree"
                            checked={formik.values.agree}
                            onChange={formik.handleChange}
                          />
                          <label className="form-check-label landing-text-white" htmlFor="agree">
                            I agree all statements in{" "}
                            <Link to="#!">Terms of service</Link>
                          </label>
                        </div>

                        <div className="d-flex justify-content-center mx-4 mb-3 mb-lg-4">
                          <button
                            type="submit"
                            className="btn btn-primary btn-lg w-100"
                          >
                            Login
                          </button>
                        </div>
                      </form>

                      <div className="d-flex justify-content-evenly text-center   ">
                        <div className="align-center">
                          <p>
                            <Link
                              to="/forgot-password"
                              onClick={() => navigate("/forgot-password")}
                              className="text-decoration-none fs-6 text-dark landing-text-white"
                            >
                              Forgot Password?
                            </Link>
                          </p>
                        </div>
                        <div className="ps-2">
                          <p>
                            <Link
                              to="/register"
                              onClick={() => navigate("/register")}
                              className="text-decoration-none fs-6 text-dark landing-text-white"
                            >
                              Create an account
                            </Link>
                          </p>
                        </div>
                      </div>

                      <div className="d-flex align-items-center my-4">
                        <hr className="flex-grow-1 or-content landing-text-white" />
                        <div
                          className="input-style or-content  border rounded-circle text-center landing-text-white p-2"

                        >
                          OR
                        </div>
                        <hr className="flex-grow-1 landing-text-white" />
                      </div>

                      <div className="google-cont d-flex justify-content-center   
                          mt-4 mb-4">
                        <GoogleLogin
                          onSuccess={handleGoogleLoginSuccess}
                          onError={handleGoogleLoginFailure}
                          useOneTap={true}
                        />
                      </div>

                    </div>
                    <div className="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2 ">
                      <img
                        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/draw1.webp"
                        className="img-fluid"
                        alt="Sample"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer />
    </>
  );
}

export default Login;